import { render, staticRenderFns } from "./companyintroduce.vue?vue&type=template&id=36262978&scoped=true"
import script from "./companyintroduce.vue?vue&type=script&lang=js"
export * from "./companyintroduce.vue?vue&type=script&lang=js"
import style0 from "./companyintroduce.vue?vue&type=style&index=0&id=36262978&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36262978",
  null
  
)

export default component.exports